export default "__VITE_ASSET__DvDhB3AQ__"